// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './index_scroll.module.less';

interface i_header_item {
    id: string;
    text: string;
    level: number;
}

interface i_index_scroll_props {
    headers: i_header_item[];
    active_header_id: string | null;
    on_header_click: (header_id: string)=>void;
}

export const Index_scroll = (props: i_index_scroll_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.index_scroll_container}>
      <p className={cn(theme.p12, theme.med, styles.title)}>
        IN THIS ARTICLE:
      </p>
      <ul className={styles.header_list}>
        {props.headers.map(header=><li
          key={header.id}
          className={cn(
            styles.header_item,
            header.id == props.active_header_id && styles.active
          )}
          onClick={()=>props.on_header_click(header.id)}
        >
          <p className={cn(theme.p14, styles.header_text)}>
            {header.text}
          </p>
        </li>)}
      </ul>
    </div>;
};
